import * as tslib_1 from "tslib";
import RippleRender from './RippleRender';
import enableKeyboardFocus from './enableKeyboardFocus';
var defaultRippleConfig = {
    enableKeyboardFocus: true,
};
/**
 * 启用Ripple效果的元素
 *
 * @export
 * @class RippleElement
 */
var RippleElement = /** @class */ (function () {
    function RippleElement(element, rippleConfig) {
        if (rippleConfig === void 0) { rippleConfig = defaultRippleConfig; }
        this.element = element;
        this.rippleConfig = tslib_1.__assign({}, defaultRippleConfig, rippleConfig);
        this.rippleRender = new RippleRender(element, this.rippleConfig);
        this.enable();
    }
    /**
     * 取消ripple效果
     */
    RippleElement.prototype.cancel = function () {
        var _this = this;
        this.rippleRender.clean();
        if (this.keyboardFocusHandler) {
            this.keyboardFocusHandler.clean();
        }
        this.eventTriggers.forEach(function (_a) {
            var name = _a.name, callback = _a.callback;
            _this.element.removeEventListener(name, callback, false);
        });
    };
    /**
     * 禁用ripple效果
     */
    RippleElement.prototype.disable = function () {
        this.enabled = false;
        this.cancel();
    };
    /**
     * 启用ripple效果
     */
    RippleElement.prototype.enable = function () {
        var _this = this;
        if (this.enabled) {
            return;
        }
        this.eventTriggers = [];
        this.enabled = true;
        this.enableDesktopClickRipple();
        this.enableMobileTouchRipple();
        this.eventTriggers.forEach(function (_a) {
            var name = _a.name, callback = _a.callback;
            _this.element.addEventListener(name, callback, false);
        });
        if (this.rippleConfig.enableKeyboardFocus) {
            this.onSpaceDownWhenKeyboardFocus = this.onSpaceDownWhenKeyboardFocus.bind(this);
            this.onSpaceUpWhenKeyboardFocus = this.onSpaceUpWhenKeyboardFocus.bind(this);
            this.enableKeyboardFocusRipple();
        }
    };
    RippleElement.prototype.enableDesktopClickRipple = function () {
        this.eventTriggers.push({
            name: 'mousedown',
            callback: this.rippleRender.addRipple,
        }, {
            name: 'mouseup',
            callback: this.rippleRender.removeRipple,
        }, {
            name: 'mouseleave',
            callback: this.rippleRender.removeRipple,
        });
    };
    RippleElement.prototype.enableMobileTouchRipple = function () {
        this.eventTriggers.push({
            name: 'touchstart',
            callback: this.rippleRender.addRipple,
        }, {
            name: 'touchmove',
            callback: this.rippleRender.removeRipple,
        }, {
            name: 'touchend',
            callback: this.rippleRender.removeRipple,
        });
    };
    RippleElement.prototype.enableKeyboardFocusRipple = function () {
        this.keyboardFocusHandler = enableKeyboardFocus(this.element, {
            onFocus: this.rippleRender.focusRipple,
            onBlur: this.rippleRender.blurRipple,
            onSpaceDown: this.onSpaceDownWhenKeyboardFocus,
            onSpaceUp: this.onSpaceUpWhenKeyboardFocus,
        });
    };
    RippleElement.prototype.onSpaceDownWhenKeyboardFocus = function (event) {
        var _this = this;
        this.rippleRender.blurRipple().then(function () { return _this.rippleRender.addRipple(); });
    };
    RippleElement.prototype.onSpaceUpWhenKeyboardFocus = function () {
        this.rippleRender.removeRipple().then(this.rippleRender.focusRipple);
    };
    return RippleElement;
}());
export default RippleElement;
//# sourceMappingURL=RippleElement.js.map